export default __webpack_public_path__ + "static/media/img-0632-moldova-half-face.2c6bb38f.png";